import React, { FC } from "react";
import { AdminFormFieldSubmit } from "./admin/formFields";
import svgIcons from "../assets/svg/svgIcons";

type TListingPageSubHeaderProps = {
  heading: string;
  buttonText?: string;
  buttonCallback?: () => void;
  hideImage?: boolean;
};

const ListingPageSubHeader: FC<TListingPageSubHeaderProps> = ({ heading, buttonText, hideImage, buttonCallback }) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-accent-blue-dark text-base font-semibold leading-6">
        {heading}
      </h2>
      {/* <div className="w-44"> DISABLED AS THIS WAS LIMITING THE BUTTON WIDTH */}
      <AdminFormFieldSubmit
        buttonDimensionClass={"h-10 w-full px-6 group"}
        customWrapperClass={`col-span-6${buttonText ? '' : ' invisible'}`}
        type="button"
        variant="primary"
        label={<span className="flex justify-center whitespace-nowrap">
          {buttonText}
          {
            !hideImage &&
            <img
              className="ml-2 transition-all group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert"
              src={svgIcons.ButtonIconPlus}
              alt={buttonText}
            />
          }
        </span>}
        onClick={buttonCallback}
      />
      {/* </div> */}
    </div>
  )
};
export default ListingPageSubHeader;
